<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <!--<button-add :pathName="addCustom"/>-->
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          size="small"
          unlink-panels
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          :picker-options="pickerOptions2"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="住户名称/房间号" @search="searchKey" style="margin-right: 5px;" />
        <!--<button-export-->
          <!--:href="exportUrl"-->
          <!--download="download.xls"-->
          <!--:beforeDownload="beforeDownload"-->
          <!--value="导出"-->
          <!--v-if="permissionCodes.indexOf('005004001') !== -1"/>-->
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Finance'
  import {errorHandler} from '../../../utils/errorHandler'
  import {bus} from '../../../utils/bus'
  import {nError, nSuccess} from '../../../utils/notice'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'water-finance-settlement-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '结算记录'
        }],
        // addCustom: 'amount-add',
        exportUrl: '',
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'enterpriseName',
          label: '住户名称'
        }, {
          prop: 'roomInfoNumber',
          label: '房间号'
        }, {
          prop: 'settleBalance',
          label: '结算金额'
        }, {
          prop: 'settleTime',
          label: '结算时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        timeValue: [],
        requestData: {
          searchKey: ''
        },
        currentLineData: {}
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getCurrentTime()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getCurrentTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.timeValue[0] = year + '-' + month + '-' + date
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      beforeDownload () {
        if (this.timeValue.length > 0) {
          this.exportUrl = `${api.exportElectricConsumptionRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&startTime=${this.timeValue[0]} 00:00:00&endTime=${this.timeValue[1]} 23:59:59`
        } else {
          this.exportUrl = `${api.exportElectricConsumptionRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`
        }
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        reqData.startTime = ''
        reqData.endTime = ''
        if (this.timeValue) {
          if (this.timeValue.length > 0) {
            reqData.startTime = `${this.timeValue[0]} 00:00:00`
            reqData.endTime = `${this.timeValue[1]} 23:59:59`
          }
        }
        this.$axios.post(api.getWaterSettlementPage, reqData)
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              if (v.payTime) {
                v.payTime = v.payTime.slice(0, 19)
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          })
          .catch(errorHandler('获取结算记录失败'))
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .el-select-dropdown {
    min-height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/WaterFinance/WaterFinanceSettlementRecord.vue